"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    HELP_URL = "https://intercom.help/shootstahub/en";

function openHelpPage() {
  window.open(HELP_URL, "_blank");
}

function HelpCenterButton() {
  return _react["default"].createElement(_uiKit.Link, {
    button: !0,
    onClick: openHelpPage
  }, "Help Center");
}

var _default = (0, _react.memo)(HelpCenterButton);

exports["default"] = _default;